module.exports = __webpack_public_path__ + "img/check2.507fe28a.svg";